import * as React from 'react';

import { cn } from 'utils/cn';

const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type, ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={cn(
        'flex h-md1 w-full rounded-small border border-sidebar-border bg-transparent px-xs3 py-xs2 text-body-regular shadow-none file:border-0 file:bg-transparent file:text-body-regular file:font-medium placeholder:text-sidebar-foreground/50 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sidebar-ring disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      type={type}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
